<template>
  <div id="btn-import">
    <Button :class="`${btnStyle} p-button-sm`" :disabled="btnDisabled">
      <label for="import-input" class="flex cursor-pointer">
        <v-icon :name="btnIcon" />
        <p class="text-[14px] ml-1">{{ name }}</p>
      </label>
    </Button>

    <input
      id="import-input"
      type="file"
      accept=".csv"
      @change="onUpload"
      @click="inputReset($event)"
      hidden
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "importButton",
  emits: ["onUpload"],
  props: {
    name: {
      type: String,
      default: "",
    },
    btnStyle: {
      type: String,
      default: "btn-primary",
    },
    btnIcon: { type: String },
    btnDisabled: { type: Boolean, default: false},
  },
  methods: {
    onUpload(event: any): void {
      this.$emit("onUpload", event);
    },
    inputReset(event: any): void {
      event.target.value = "";
    },
  },
});
</script>
